import { observer } from "mobx-react-lite";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import imageStore from "../../Mobx/Images";

// 30 רמות קבועות מראש
const SIZE_PRESETS = Array.from({ length: 30 }, (_, i) => ({
    width: 140 + i * 20,
    height: 180 + i * 28,
}));

const CardSizeSelector = () => {
    const currentLevel = SIZE_PRESETS.findIndex(
        preset =>
            preset.width === imageStore.cardSize.width &&
            preset.height === imageStore.cardSize.height
    );

    const changeLevel = (direction) => {
        const newLevel = Math.min(29, Math.max(0, currentLevel + direction));
        const { width, height } = SIZE_PRESETS[newLevel];
        imageStore.setCardSize("width", width);
        imageStore.setCardSize("height", height);
    };

    return (
        <Box
            sx={{
                px: 1.5,
                height: "37px",
                backgroundColor: "#f5f5f5",
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
            }}
        >
            <Typography variant="body2" sx={{ mr: 1, whiteSpace: "nowrap", fontSize: "0.85rem" }}>
                גודל כרטיס
            </Typography>
            <Tooltip title="הקטן">
                <span>
                    <IconButton
                        onClick={() => changeLevel(-1)}
                        disabled={currentLevel <= 0}
                        size="small"
                        sx={{ p: "4px" }}
                    >
                        <RemoveIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip
                title={`רמה ${currentLevel + 1} (${SIZE_PRESETS[currentLevel]?.width}x${SIZE_PRESETS[currentLevel]?.height})`}
            >
                <Typography sx={{ mx: 1, fontSize: "0.85rem", width: 16, textAlign: "center" }}>
                    {currentLevel + 1}
                </Typography>
            </Tooltip>
            <Tooltip title="הגדל">
                <span>
                    <IconButton
                        onClick={() => changeLevel(1)}
                        disabled={currentLevel >= 29}
                        size="small"
                        sx={{ p: "4px" }}
                    >
                        <AddIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
};

export default observer(CardSizeSelector);
